<div class="status-button" (click)="changeStatus('public')">
  <div class="status-title">عمومی</div>
  <div class="status-indicator-holder">
    <div
      [ngClass]="
        status === 'public'
          ? 'status-indicator-active'
          : 'status-indicator-deactive'
      "
    ></div>
  </div>
</div>
<div
  class="status-button"
  style="border-bottom: 1px solid rgb(200, 199, 204)"
  (click)="changeStatus('private')"
>
  <div class="status-title">خصوصی</div>
  <div class="status-indicator-holder">
    <div
      [ngClass]="
        status === 'private'
          ? 'status-indicator-active'
          : 'status-indicator-deactive'
      "
    ></div>
  </div>
</div>
